import TextInputs from '@/components/Editor/Form/fields/TextInputs';
import RevealPill, { PillChip } from '@/components/Editor/Form/fields/RevealPill';
import { jsx as _jsx } from "react/jsx-runtime";

const ColumnLabels = _ref => {
  let {
    nameSpace,
    columnCount = 0,
    labels = [],
    isColumn = true,
    openButtonVariant,
    onChange
  } = _ref;
  const label = `${isColumn ? 'Column' : 'Bar'} Labels`;
  const modifiedColumnCount = labels.filter(label => Boolean(label)).length;
  const isModified = modifiedColumnCount > 0;
  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    variant: isModified ? 'active' : '',
    activeState: /*#__PURE__*/_jsx(PillChip, {
      count: modifiedColumnCount
    }),
    openButtonVariant: openButtonVariant,
    children: /*#__PURE__*/_jsx(TextInputs, {
      nameSpace: nameSpace,
      label: label,
      caption: `Add a custom label to each ${isColumn ? 'column' : 'bar'}`,
      inputPlaceholder: "Column label",
      inputValues: labels,
      inputsCount: columnCount,
      onChange: values => {
        onChange('', {
          columnLabels: values
        });
      }
    }, nameSpace)
  });
};

export default ColumnLabels;